/**
 * Query key that opens the counter scan as soon as the patient file is
 * displayed.
 *
 * It is how the detection pop-up hands over: the pop-up cannot host the scan
 * dialog (its window is sized to its own content), so it sends the main window
 * to the patient file with this flag, and the file's birthday gift reminder
 * opens the scan on arrival. The key is removed when the scan closes, so a
 * reload does not reopen it.
 */
export const BIRTHDAY_GIFT_SCAN_QUERY_KEY = 'birthdayGiftScan';
